import React, { useEffect, useState, useMemo } from 'react';
import { Badge } from 'reactstrap'
import { useHistory } from 'react-router-dom';
import { ConfigServer } from '../../data/config';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { useRef } from 'react';
import validateNegative from '../../utils/validations/validationNegativePrice'
import validatePrice from '../../utils/validations/validationPrice'
import { getAllInformationAgreement } from '../../services/company/company';
import { getInformationQuoter } from '../../services/quoter/quoterService';
import { getInformationCatalogsDiscounts } from '../../services/discounts/discounts';
import 'moment/locale/es';
import moment from 'moment';
import { semlab, cedimi } from '../../constant/globalConstantsTypeClients';



export const useQuatation = () => {

    const history = useHistory();

    let typeCommercialLine = localStorage.getItem('commercialLineId');
    let branch = localStorage.getItem('branchId')
    let percentage_urgent_work_order = localStorage.getItem('percentage_urgent_work_order');
    let url = localStorage.getItem('url_helen');
    let _discount_special_referenced_exams = localStorage.getItem('discount_special_referenced_exams');
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete] = useSweetAlert();


    const [modalTitle, setModalTitle] = useState("");
    const [modal, setModal] = useState(false);
    const [modalRepeatProfile, setModalRepeatProfile] = useState(false);
    const [modalViewExamsP, setModalViewExamsP] = useState(false);

    // ? QUOTER
    const [viewButtons, setViewButtons] = useState(true);
    const [examProfileState, setExamProfileState] = useState([]);
    const [idQuoter, setIdQuoter] = useState(0);
    const [viewExamsProfile, setViewExamsProfile] = useState([]);
    const [totalW, setTotalW] = useState(0.00);
    const [subTotalW, setSubTotalW] = useState(0.0);
    const [totalTaxesW, setTotalTaxesW] = useState(0.0);
    const [totalDiscountW, setTotalDiscountW] = useState(0.0);
    const [lab, setLab] = useState(false);


    // ?  CONFIGURATION INDICATIONS
    const [itemsTree, setItemsTree] = useState([]);
    const treeviewRef = useRef(null);

    // ? CONFIGURATION TYPE CLIENT
    const [chekTypeClient, setChekTypeClient] = useState(semlab === url ? 1 : 0);
    const [loadingQuoter, setLoadingQuoter] = useState(false);
    const [listAgreement, setListAgreement] = useState([]);

    // ? CONFIGURATION SEARCH QUOTER
    const [dataQuoter, setDataQuoter] = useState([])
    // console.log("🍋 dataQuoter", dataQuoter);

    const [isHovered, setIsHovered] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [loadingDownloadId, setLoadingDownloadId] = useState(null);
    const [loadingPreviewId, setLoadingPreviewId] = useState(null);
    const [allQuoters, setAllQuoters] = useState([]);
    const [loadingQuoterFilter, setLoadingQuoterFilter] = useState(false);

    // ? CONFIGURATION PRELOADED DISCOUNTS
    const [listPreloaded, setListPreloaded] = useState([])
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [viewQuoter, setViewQuoter] = useState(false)

    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [viewDetailQuoter, setViewDetailQuoter] = useState(false)
    const [viewIndication, setViewIndication] = useState(false)
    const [loadingSend, setLoadingSend] = useState(false)
    const [activeIndex, setActiveIndex] = useState(semlab === url ? 1 : 0);

    const [selectedCompany, setSelectedCompany] = useState(null);
    
    //? discount 
    const [loadingDiscount, setLoadingDiscount] = useState(false);

    //? BUTTON FOOTER
    const [activeView, setActiveView] = useState(
        semlab === url ? 1 : 0
    );

    //? ALERT GLOBAL
    const [pendingType, setPendingType] = useState(null);
    const [pendingQuotationType, setPendingQuotationType] = useState(null);

    const [duplicateMessage, setDuplicateMessage] = useState("");

    const [duplicateTitle, setDuplicateTitle] = useState("");


    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");

    //? CUSTOM ALERT GLOBAL
    const [customAlert, setCustomAlert] = useState({
        visible: false,
        mode: "alert",
        type: "info",
        title: "",
        message: "",
        buttonText: "Aceptar",
        cancelText: null,
        onAccept: null,
        onCancel: null
    });


    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues] = useForm({
        observations: "",
        listQuoterTest: [],
        id_profileExam: 0,
        name: url === "https://cedimi.helen-sw.com" ? "A" : "",
        paternal_surname: url === "https://cedimi.helen-sw.com" ? "QUIEN" : "",
        maternal_surname: url === "https://cedimi.helen-sw.com" ? "CORRESPONDA" : "",
        arrayCurves: [],
        email: "",
        phone: "",
        id_agreement: null,
        date_ini: "",
        date_end: "",
        code_quoter: "",
        id_preloaded_discount: null

    });

    const { observations, listQuoterTest, id_profileExam, name, paternal_surname, maternal_surname, email, phone, id_agreement, date_ini, date_end, code_quoter, id_preloaded_discount } = formValues;

    //#endregion 


    const toggle = () => {
        setModal(!modal);
    }

    const toggleRepeatProfile = () => {
        setModalRepeatProfile(!modalRepeatProfile);
    }

    const toggleModalViewExams = () => {
        setModalViewExamsP(!modalViewExamsP);
    }


    const [validationsSG, setvalidationsSG] = useState({
        nameV: false,
        paternal_surnameV: false,
        maternal_surnameV: false,
    });
    const [validationsTest, setValidationsTest] = useState({
        valid_repeat_test: false,
        valid_exist_exam_profile: false,
        valid_conteins_exam: false,
        message_validation: ""
    });

    const [validationsRepeat, setValidationsRepeat] = useState({
        name_profile: "",
        repeat_profiles: [],
        repeat_exams: []
    });

    useEffect(() => {
        getQuoter()
        urlLab();

    }, []);


    useEffect(() => {
        getPreloadedDiscounts();

    }, [url === cedimi])


    //#region CUSTOM ALERT
    const showCustomAlert = ({
        mode = "alert",
        type = "info",
        title,
        message,
        buttonText = "Aceptar",
        cancelText = null,
        onAccept = null,
        onCancel = null
    }) => {

        setCustomAlert({
            visible: true,
            mode,
            type,
            title,
            message,
            buttonText,
            cancelText,

            onAccept: () => {

                setCustomAlert(prev => ({
                    ...prev,
                    visible: false
                }));

                if (onAccept) {
                    onAccept();
                }

            },

            onCancel: () => {

                setCustomAlert(prev => ({
                    ...prev,
                    visible: false
                }));

                if (onCancel) {
                    onCancel();
                }

            }

        });

    };
    
    //#endregion

    // * CATALOG
    const getPreloadedDiscounts = async () => {
        const discount = await getInformationCatalogsDiscounts(false);

        if (discount.length > 0) {
            const list = discount?.map(_find => {
                return {
                    value: _find?.id_preloaded_discount,
                    label: _find?.name + "-" + _find?.description,
                    valuePercentage: _find?.percentage
                }
            });
            setListPreloaded(list)
        }
    }

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    // ? TYPE CLIENT
    const getClients = async (_type) => {
        const company = await getAllInformationAgreement(3);
        if (company?.length > 0) {
            const list = company
                ?.filter(_find => !_find?.is_micro)
                .map(_find => {
                    return {
                        value: _find?.id_agreement,
                        label: _find?.name_company + "-" + _find?.contract_number,
                        id_company: _find?.id_company,
                        is_list_limited: _find?.is_list_limited ?? true
                    }
                });
            setListAgreement(list);
        }
    }


    // ? CONFIGURATION TYPE CLIENT
    const handleChangeTypeClient = (_typeClient) => {

        if (_typeClient === 1) {
            setChekTypeClient(1);
            handleUpdateValues({
                observations: "",
                listQuoterTest: [],
                id_profileExam: 0,
                name: url === "https://cedimi.helen-sw.com" ? "A" : "",
                paternal_surname: url === "https://cedimi.helen-sw.com" ? "QUIEN" : "",
                maternal_surname: url === "https://cedimi.helen-sw.com" ? "CORRESPONDA" : "",
                arrayCurves: [],
                email: "",
                phone: "",
                id_agreement: null
            });

            setViewButtons(true);
            setExamProfileState({});
            setViewQuoter(false);

        }
        else if (_typeClient === 0) {

            handleUpdateValues({
                observations: "",
                listQuoterTest: [],
                id_profileExam: 0,
                name: url === "https://cedimi.helen-sw.com" ? "A" : "",
                paternal_surname: url === "https://cedimi.helen-sw.com" ? "QUIEN" : "",
                maternal_surname: url === "https://cedimi.helen-sw.com" ? "CORRESPONDA" : "",
                arrayCurves: [],
                email: "",
                phone: "",
                id_agreement: null
            });

            setChekTypeClient(0);
            setViewButtons(true);
            setExamProfileState({});
            setViewQuoter(false);

        }
        else {

            setChekTypeClient(3);

            getClients();

            handleUpdateValues({
                observations: "",
                listQuoterTest: [],
                id_profileExam: 0,
                name: url === "https://cedimi.helen-sw.com" ? "A" : "",
                paternal_surname: url === "https://cedimi.helen-sw.com" ? "QUIEN" : "",
                maternal_surname: url === "https://cedimi.helen-sw.com" ? "CORRESPONDA" : "",
                arrayCurves: [],
                email: "",
                phone: "",
                id_agreement: null
            });

            setViewButtons(true);
            setExamProfileState({});
            setViewQuoter(false);
        }
    };


    const urlLab = async () => {
        if (url === "https://semlab.helen-sw.com") {
            setLab(true)
        } else {
            setLab(false)
        }
    }

    // ? CONFIGURATION SEARCH QUOTER
    const getQuoter = async (_clean) => {
        setLoadingQuoterFilter(true);

        try {
            let _mfrom = (date_ini === '') ? moment().format("YYYY-MM-DD") : moment(date_ini).format("YYYY-MM-DD");
            let _mto = (date_end === '') ? moment().format("YYYY-MM-DD") : moment(date_end).format("YYYY-MM-DD");

            const infoQuoter = await getInformationQuoter(_mfrom, _mto, code_quoter);
// console.log("INFO QUOTER", infoQuoter);
            if (infoQuoter !== null) {
                let _quoter = [];
                infoQuoter.listQuoters.forEach((_find, _key) => {

                    _quoter.push({
                        id_quoter: _find?.id_quoter,
                        code: _find?.code,
                        client: _find?.name_user + " " + _find?.aPaterno + " " + _find?.aMaterno,
                        status: _find?.status,
                        used_at: _find?.used_at
                        ? moment(_find.used_at).format("DD/MM/YYYY HH:mm")
                        : "N/A",
                        company_name: _find?.company_name,
                        created_at: _find?.created_at,
                        client_type: _find?.company_name
                            ? <Badge color="warning">Empresa</Badge>
                            : <Badge color="primary">Particular</Badge>,
                        client_type_text: _find?.company_name ? "Empresa" : "Particular",
                    })

                });
                setDataQuoter(_quoter)
                setAllQuoters(_quoter);
            }
            else {
                setAllQuoters([]);
                setDataQuoter([]);
            }

        }
        finally {
            setLoadingQuoterFilter(false);
        }


    }

    // ? CONFIGURATION FILTER
    const handleFilterValues = async (e) => {
        if (e && e?.target?.value !== undefined && e?.target?.value !== "") {

            let _value = e?.target?.value;
            let _name_input = e?.target?.name;

            switch (_name_input) {
                case "start_date":
                    handleUpdateValues({
                        ...formValues,
                        date_ini: _value,
                    });
                    break;
                case "end_date":

                    handleUpdateValues({
                        ...formValues,
                        date_end: _value,
                    });
                    break
                default:
                    handleUpdateValues({
                        ...formValues,
                        code_quoter: _value,
                    });
                    break;
            }
        }
    }

    const searchQuotes = () => {
        getQuoter();
    }

    // ? DOWNLOAD PDF
    const downdloadQuoter = async (id_quoter = 0) => {
        let _quoter = id_quoter === 0 ? idQuoter : id_quoter

        setLoadingDownloadId(_quoter);
        try {

            let data = {
                "id_quoter": _quoter,
                "print_result": true,
                "send_email": false,
                "email_client": ""
            }


            let raw = JSON.stringify(data);

            let token = localStorage.getItem("token");
            await fetch(ConfigServer.serverUrl + "/api/Quoter/CreateDocumentQuoter", {
                method: 'POST',
                body: raw,
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {

                    if (response.status !== 200) {
                        // createSweet("warning", "warning", "No se descargo el PDF");
                        showToastAlert(
                            "error",
                            "Error",
                            "No se descargo el PDF."
                        );
                        return;
                    }

                    return response.blob();
                })
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Cotizacion.pdf")
                    document.body.appendChild(link);
                    link.style.display = 'none';
                    link.click();
                });
        } finally {
            setLoadingDownloadId(null);
        }
    }

    // ? SEARCH EXAMS AND PROFILE
const handleSelectExamChange = (e) => {
// console.trace("HANDLE SELECT", e.target.value);
      if (e.target.name === "clearAllExams") {

        handleUpdateValues({
            ...formValues,
            listQuoterTest: [],
            id_profileExam: 0
        });

        return;
    }

    let examProfile = e.target.value; console.log("HANDLE SELECT", e.target.value);


    if (examProfile !== 0 && examProfile !== null) {

        examProfile = examProfile.split('-');

        let idTest = examProfile[0];
        let typeTest = examProfile[1];

        console.log("ID TEST", idTest);
        console.log("TYPE TEST", typeTest);

        let nameTypeTest = typeTest === "0"
            ? "Exam"
            : "Profile";

        if (nameTypeTest === "Profile") {
            handleGetProfile(idTest);
        }
        else {
            handleGetExam(idTest);
        }
    }
}

    const handleGetProfile = async (id_profile, valid_exist = -1) => {
        // console.log("ENTRO A HANDLE GET PROFILE", id_profile);
        // console.log("selectedCompany2", selectedCompany);
        // console.log("id_agreement2", id_agreement);
        let _valid_url = chekTypeClient === 3 ?
            `Profiles/FindProfileId/${id_profile},${branch},${typeCommercialLine},0,${id_agreement.id_company},0?validation_strict=true&is_membership=false&idAgreement=${id_agreement.value}`
            :
            `Profiles/FindProfileId/${id_profile},${branch},${typeCommercialLine},0,0,0?validation_strict=true&is_membership=false`
        let listTemp = await handleRequest("GET", _valid_url, "Buscar perfles");
        // console.log("id_agreement2", id_agreement);
        // console.log("selectedCompany2", selectedCompany);
        // console.log("chekTypeClient2", chekTypeClient);
        let list = listQuoterTest;

        if (listTemp !== null) {
            const { price } = listTemp;
            const { name } = listTemp;

            let price_Agremment = 0;
            let id_agreement = 0;


            let _validate_price = "";
            _validate_price = validateNegative(price)


            if (_validate_price === "true" || _validate_price) {
                // createSweett("Estudios", `No se puede agregar el estudio ${name} con precio negativo de  ${price}.`, "error");
                showToastAlert(
                    "warning",
                    "Estudios",
                    `No se puede agregar el estudio ${name} con precio negativo de ${price}.`
                );

                return;
            }



            const validTest = validationTest(
                null,
                id_profile,
                listTemp.listExams,
                listTemp.name
            );

            if (validTest.status !== -1 && validTest.status !== 2) {
               showDuplicateExamAlert(
                    validTest.title,
                    validTest.message
                );
                return;
            }
            else if (validTest.status === 2 && valid_exist === -1) {
                toggleRepeatProfile();
                setModalTitle("Perfiles con exámenes duplicados");
            }


            if (listTemp.agreement !== null) {

                listTemp.agreement.forEach(_find => {
                    price_Agremment = _find.price
                    id_agreement = _find.id_agreement
                });

            }

            if (chekTypeClient === 3) {
                if ((id_agreement === 0 || id_agreement === null) && !formValues.id_agreement?.is_list_limited) {
                    showInfoAlert(
                        "Estudios",
                        `No se puede agregar el estudio <strong>${name}</strong> ya que no se encuentra dentro del convenio.`
                    );
                    return;

                }


            }



            let array_specimens = [];

            listTemp.exams_specimens.forEach(specimen => {
                if (!array_specimens.find(x => x.id_specimen === specimen.id_specimen_origin)) {

                    let valorCheck = true;

                    list.forEach(item => {
                        if (item.id_specimen === parseInt(specimen.id_specimen_origin)) {
                            valorCheck = item.check_specimen;
                        }
                    });

                    array_specimens.push({
                        specimen_name: specimen.name_specimen_origin,
                        id_specimen: specimen.id_specimen_origin,
                        check_specimen: valorCheck,
                    });
                }
            });

            list.push({
                id_profile: listTemp.id_profile,
                id_exam: null,
                id_price: listTemp.id_price,
                id_profile_price: listTemp.id_price,
                price: listTemp.price,
                name: listTemp.name,
                code: listTemp.code,
                // listIndications: listTemp.listExamIndications,
                listIndications: listTemp.listIndications,
                listLabIndications: listTemp.listLabIndications,
                is_urgent: false,
                is_curve: listTemp.is_curve,
                curves: listTemp.listCurves,
                abbreviation: listTemp.abbreviation,
                specimen_name: "",
                id_specimen: null,
                array_specimens: array_specimens,
                config_iva: listTemp.config_iva,
                value_iva: listTemp.value_iva,
                urgent_price: 0,
                id_profile_curve_price: 0,
                listExams: listTemp.listExams,
                percentage: 0,
                price_Agremment: price_Agremment,
                id_agreement: id_agreement,
                enable_discounts: listTemp.enable_discounts,
                delivery_time: listTemp.delivery_time

            });

            //console.log(list)


            handleUpdateValues({
                ...formValues,
                listQuoterTest: [...list]
            });
            validatePreloadedDiscount(true)



            setExamProfileState({});
        }
    }

    const handleGetExam = async (id_exam) => {
        let list = listQuoterTest;
        // console.log("selectedCompany1", selectedCompany);
        // console.log("id_agreement1", id_agreement);
        let _valid_url = chekTypeClient === 3 ?
            `Exam/GetPriceFromExam/${id_exam},${branch},${typeCommercialLine},0,${id_agreement.id_company},0,true?idAgreement=${id_agreement.value}`
            :
            `Exam/GetPriceFromExam/${id_exam},${branch},${typeCommercialLine},0,0,0,true?is_membership=false`
            // console.log("id_agreement", id_agreement);
            // console.log("selectedCompany", selectedCompany);
            // console.log("chekTypeClient", chekTypeClient);

        let listTemp = await handleRequest("GET", _valid_url, "Examenes");

        if (listTemp !== null) {
            const { price } = listTemp;
            const { name } = listTemp;


            let _validate_price = "";
            let _price_null = ""

            let price_Agremment = 0;
            let id_agreement = 0;

            _price_null = validatePrice(price)
            if (_price_null === "true" || _price_null) {
                // createSweett("Estudios", `No se puede agregar el estudio ${name} sin precio , favor de verificarlo en el tarifario.`, "error");
                showToastAlert(
                    "warning",
                    "Estudios",
                    `No se puede agregar el estudio <strong>${name}</strong> sin precio, favor de verificarlo en el tarifario.`
                );
                return;
            }
            _validate_price = validateNegative(price)


            if (_validate_price === "true" || _validate_price) {
                // createSweett("Estudios", `No se puede agregar el estudio ${name} con precio negativo de  ${price}.`, "error");
                showToastAlert(
                    "warning",
                    "Estudios",
                    `No se puede agregar el estudio ${name} con precio negativo de ${price}.`
                );
                return;
            }


            const validationExam = validationTest(id_exam);

            if (validationExam.status !== -1 && validationExam.status !== 2) {
                showDuplicateExamAlert(
                    validationExam.title,
                    validationExam.message
                );
                return;
            }

            if (listTemp.agreement !== null) {

                price_Agremment = listTemp.agreement.price
                id_agreement = listTemp.agreement.id_agreement

            }

            if (chekTypeClient === 3) {
                if ((id_agreement === 0 || id_agreement === null) && !formValues.id_agreement?.is_list_limited) {
                  showInfoAlert(
                    "Estudios",
                    `No se puede agregar el estudio <strong>${name}</strong> ya que no se encuentra dentro del convenio.`
                );
                return;

                }

            }




            let valorCheck = true;

            list.forEach(item => {
                if (item.id_specimen === parseInt(listTemp.id_specimen)) {
                    valorCheck = item.check_specimen;
                }
            });






            list.push({
                id_profile: null,
                id_exam: listTemp.id_exam,
                name: listTemp.name,
                abbreviation: listTemp.abbreviation,
                code: listTemp.code,
                id_price: listTemp.id_price,
                price: listTemp.price,
                specimen_name: listTemp.name_specimen,
                id_specimen: listTemp.id_specimen,
                check_specimen: valorCheck,
                listIndications: listTemp.listIndications,
                listLabIndications: listTemp.listLabIndications,
                is_urgent: false,
                config_iva: listTemp.config_iva,
                value_iva: listTemp.value_iva,
                listExams: null,
                urgent_price: 0,
                delivery_time: listTemp.delivery_time,
                percentage: 0,
                price_Agremment: price_Agremment,
                id_agreement: id_agreement,
                enable_discounts: listTemp.enable_discounts


            });

            //console.log(list);

            handleUpdateValues({
                ...formValues,
                listQuoterTest: [...list]
            });
            validatePreloadedDiscount(true)


            setExamProfileState({});
        }
    }

    // ? CONFIGURATION ACTIONS
    const deleteExamProfile = (e, id_exam, id_profile = null) => {

        let findTest = listQuoterTest.find(x => (id_exam !== null ? x.id_exam === parseInt(id_exam) : x.id_profile === parseInt(id_profile)));

        if (findTest !== null) {
            let newListTest = listQuoterTest.filter(item => {
                if ((id_exam !== null && item.id_exam === parseInt(id_exam)) || (id_profile !== null && item.id_profile === parseInt(id_profile))) {
                    return false;
                }
                else {
                    return true;
                }
            });

            handleUpdateValues({
                ...formValues,
                listQuoterTest: newListTest,
            });
        }
    }

    const handleCheckUrgent = (index, e) => {
        let listTmp = listQuoterTest;

        listTmp[index].is_urgent = e.target.checked;

        handleUpdateValues({
            ...formValues,
            listQuoterTest: [...listTmp]
        });
    }

    const handleCheckSpecimen = (id_exam, id_profile = null, id_specimen = null) => {
        let allRequisitionExams = listQuoterTest;

        let findRequestExam = allRequisitionExams.find(r => (id_exam !== null ? r.id_exam === parseInt(id_exam) : r.id_profile === parseInt(id_profile)));

        let valor = 0;
        let sub = null;

        if (id_specimen !== null) {
            sub = findRequestExam.array_specimens.find(x => x.id_specimen === id_specimen);
            valor = !sub.check_specimen;
        }
        else {
            valor = !findRequestExam.check_specimen;
        }

        allRequisitionExams.map(item => {
            if (item.array_specimens) {
                item.array_specimens.map(specimen => {
                    if (sub === null) {
                        if (specimen.id_specimen === findRequestExam.id_exam) {
                            specimen.check_specimen = valor;
                        }
                    }
                    else {
                        if (specimen.id_specimen === sub.id_specimen) {
                            specimen.check_specimen = valor;
                        }
                    }

                    return specimen;
                });
            }
            else {
                if (sub === null) {
                    if (item.id_specimen === findRequestExam.id_specimen) {
                        item.check_specimen = valor;
                    }
                }
                else {
                    if (item.id_specimen === sub.id_specimen) {
                        item.check_specimen = valor;
                    }
                }
            }

            return item;
        });

        handleUpdateValues({
            ...formValues,
            listQuoterTest: allRequisitionExams
        });
    }

    const handleViewExamsProfile = (id_profile) => {
        let findExams = listQuoterTest.find(x => x.id_profile === parseInt(id_profile));
        ////console.log(findExams);
        if (findExams) {
            setViewExamsProfile(findExams.listExams);
            toggleModalViewExams();
        }
    }

    const handleCancellQuoter = () => {
        handleUpdateValues({
            observations: "",
            listQuoterTest: [],
            id_profileExam: 0,
            name: url === "https://cedimi.helen-sw.com" ? "A" : "",
            paternal_surname: url === "https://cedimi.helen-sw.com" ? "QUIEN" : "",
            maternal_surname: url === "https://cedimi.helen-sw.com" ? "CORRESPONDA" : "",
            arrayCurves: [],
            email: "",
            phone: "",
        });

        setExamProfileState({});
    }

    const handleChangePercentage = (e, id_exam, id_profile = null) => {
        let _list = listQuoterTest;
        let _value = e.target.value;

        let findTest = _list.find(x => (id_exam !== null ? x.id_exam === parseInt(id_exam) : x.id_profile === parseInt(id_profile)));

        if (findTest !== undefined) {
            findTest.percentage = parseInt(_value);
        }

        handleUpdateValues({
            ...formValues,
            listQuoterTest: [..._list]
        });
    }

    // ? PENDING
    // const validatePreloadedDiscount = async (_is_active = false) => {

    //     if (id_preloaded_discount === undefined) {
    //         return;
    //     }

    //     if (!_is_active) {
    //         setLoading(true);
    //     }
    //     setProgress(0);

    //     if (id_preloaded_discount == null)
    //         return;

    //     await new Promise(r => setTimeout(r, 700));
        
    //     let progressInterval = setInterval(() => {
    //         setProgress(prevProgress => {
    //             if (prevProgress >= 90 && prevProgress < 100) {

    //                 if (id_preloaded_discount !== null) {
    //                     if (id_preloaded_discount.value !== "" && id_preloaded_discount.value > 0) {
    //                         let _allExams = formValues?.listQuoterTest;

    //                         const _update_Preloaded = _allExams.map(_find => {
    //                             _find.id_common_discount = 0;
    //                             _find.id_preloaded_discount = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? id_preloaded_discount.value : 0) : id_preloaded_discount.value;
    //                             _find.auto_redeem = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? true : false) : true;
    //                             _find.discount = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? id_preloaded_discount.valuePercentage : 0) : id_preloaded_discount.valuePercentage;
    //                             _find.percentage = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? id_preloaded_discount.valuePercentage : 0) : id_preloaded_discount.valuePercentage;
    //                             return _find;
    //                         });

    //                         handleUpdateValues({
    //                             ...formValues,
    //                             listQuoterTest: [
    //                                 ..._allExams.filter(_find => _find.is_referenced && url !== cedimi),
    //                                 ..._update_Preloaded
    //                             ]
    //                         });

    //                         if (!_is_active) {
    //                             // createSweet("info", "success", "Se ha seleccionado correctamente el descuento.");
    //                             showToastAlert(
    //                                 "success",
    //                                 "Descuento aplicado",
    //                                 "Se ha seleccionado correctamente el descuento."
    //                             );
    //                         }
    //                     }
    //                 }
    //             }

    //             if (prevProgress >= 100) {
    //                 clearInterval(progressInterval);
    //                 return 100;
    //             }

    //             return prevProgress + 10;
    //         });
            
    //     }, 100);
    // };

    const validatePreloadedDiscount = async (_is_active = false) => {

        if (id_preloaded_discount === undefined || id_preloaded_discount === null) {
            return;
        }

        if (!_is_active) {
            setLoading(true);
        }
        setProgress(0);

        await new Promise(resolve => setTimeout(resolve, 700));

        return new Promise((resolve) => {

            const progressInterval = setInterval(() => {

                setProgress(prevProgress => {

                    const nextProgress = prevProgress + 10;

                    if (nextProgress >= 100) {

                        clearInterval(progressInterval);
                        if (id_preloaded_discount.value !== "" && id_preloaded_discount.value > 0) {
                            let _allExams = formValues?.listQuoterTest;

                            const _update_Preloaded = _allExams.map(_find => {
                                _find.id_common_discount = 0;
                                _find.id_preloaded_discount = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? id_preloaded_discount.value : 0) : id_preloaded_discount.value;
                                _find.auto_redeem = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? true : false) : true;
                                _find.discount = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? id_preloaded_discount.valuePercentage : 0) : id_preloaded_discount.valuePercentage;
                                _find.percentage = _discount_special_referenced_exams === "True" ? (_find.enable_discounts ? id_preloaded_discount.valuePercentage : 0) : id_preloaded_discount.valuePercentage;
                                return _find;
                            });

                            handleUpdateValues({
                                ...formValues,
                                listQuoterTest: [
                                    ..._allExams.filter(_find => _find.is_referenced && url !== cedimi),
                                    ..._update_Preloaded
                                ]
                            });
                        }

                        if (!_is_active) {
                            showToastAlert(
                                "success",
                                "Descuento aplicado",
                                "Se ha aplicado correctamente el descuento."
                            );
                        }

                        resolve();

                        return 100;
                    }

                    return nextProgress;

                });

            }, 100);

        });
    };


    const removePreloadedDiscount = () => {

        const updatedExams = formValues?.listQuoterTest?.map(exam => ({
            ...exam,
            id_preloaded_discount: 0,
            id_common_discount: 0,
            auto_redeem: false,
            discount: 0,
            percentage: 0
        }));

        handleUpdateValues({
            ...formValues,
            id_preloaded_discount: null,
            listQuoterTest: updatedExams
        });

        // createSweet(
        //     "info",
        //     "success",
        //     "Cotización",
        //     "Se ha eliminado el descuento seleccionado."
        // );

        showToastAlert(
            "success",
            "Descuento eliminado",
            "Se ha eliminado el descuento seleccionado."
        );
    };







    // #region CREATE QUOTER
    const saveCreate = async () => {

        // Ejecutar validación de campos
        const quotationHasErrors = validationQuatation();

        const camposFaltantes = [];

        if (!formValues.name?.trim()) {
            camposFaltantes.push("Nombre");
        }

        if (!formValues.paternal_surname?.trim()) {
            camposFaltantes.push("Apellido paterno");
        }

        if (!formValues.maternal_surname?.trim()) {
            camposFaltantes.push("Apellido materno");
        }

        if (camposFaltantes.length > 0) {
            showToastAlert(
                "warning",
                "Datos incompletos",
                `Faltan por llenar los siguientes datos: ${camposFaltantes.join(", ")}`
            );
        }

        if (quotationHasErrors || camposFaltantes.length > 0) {
            return;
        }
        setLoadingCreate(true);

        try {

            let body = {
                id_agreement: chekTypeClient === 3
                    ? formValues.id_agreement?.value
                    : 0,

                id_patient: 0,
                id_branch: branch,
                name: formValues.name,
                paternal_surname: formValues.paternal_surname,
                maternal_surname: formValues.maternal_surname,
                observations: formValues.observations,
                email: formValues.email,
                phone: formValues.phone,
                ListQuoterTests: listQuoterTest
            };

            let listTemp = await handleRequest( 'POST', "Quoter", "Cotizacion", body);

            if (listTemp !== null) {
                setViewQuoter(true);

                let idQuoter = listTemp.id_quoter;
                if (idQuoter > 0) {
                    setIdQuoter(idQuoter);
                }
                showToastAlert(
                    "success",
                    "Cotización",
                    "Se creo correctamente"
                );
            }
        } finally {

            setLoadingCreate(false);
        }
    }

    const sentPdf = async () => {
        setLoadingSend(true);
        try {

            let data = {
                id_quoter: idQuoter,
                print_result: false,
                send_email: true,
                email_client: formValues.email
            };


            let raw = JSON.stringify(data);
            let token = localStorage.getItem("token");

            await fetch(ConfigServer.serverUrl + "/api/Quoter/CreateDocumentQuoter", {
                method: 'POST',
                body: raw,
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status === 200) {
                        // createSweet("success", "success", "Correo enviado correctamente");

                        showToastAlert(
                            "success",
                            "Correo",
                            "Correo enviado correctamente."
                        );
                    }
                    else {
                        showToastAlert(
                            "error",
                            "Correo",
                            "El envío de a correo no fue exitoso."
                        );
                        // createSweet("warning", "warning", "El envio de a correo no fue exitoso");
                    }
                })
        } finally {
            setLoadingSend(false);

        }









    }

    const downdloadpdf = async (idQuoterr = 0) => {

        let data = {
            "id_quoter": idQuoter,
            "print_result": true,
            "send_email": false,
            "email_client": ""
        }


        let raw = JSON.stringify(data);
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/Quoter/CreateDocumentQuoter", {
            method: 'POST',
            body: raw,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {

                if (response.status !== 200) {
                    // createSweet("warning", "warning", "No se descargo el PDF");
                    showToastAlert(
                        "error",
                        "Error PDF",
                        "No se descargo el PDF"
                    );
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Cotizacion.pdf")
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
    }
    // # endregion


    useEffect(() => {
        let arrayNuevo = [];

        if (formValues?.listQuoterTest.length > 0) {
            let _new_Array = { profiles: [], exams: [] };

            formValues.listQuoterTest.forEach(_find => {
                let _arrayExams = [{
                    name: _find?.name ?? "-----",
                    listIndications: _find?.listIndications ?? null,
                    id_exam: _find?.id_exam ?? null,
                    listLabIndications: _find?.listLabIndications ?? null,
                    delivery_time: _find?.delivery_time ?? null
                }];

                if (_find.id_profile !== null) {
                    _new_Array.profiles.push({
                        name: _find?.name ?? "-----",
                        listIndications: _find?.listIndications ?? null,
                        id_profile: _find?.id_profile ?? null,
                        listLabIndications: _find?.listLabIndications ?? null
                    });
                } else {
                    _new_Array.exams.push(_arrayExams[0]);
                }
            });

            if (_new_Array.profiles.length > 0 || _new_Array.exams.length > 0) {
                arrayNuevo.push(_new_Array);
            }
        }
        let tree = createTree(arrayNuevo);
        setItemsTree(tree);
    }, [formValues]);

    const createTree = (_array) => {

        let tree = [];

        _array.forEach(_find => {
            // ? EXAMS
            if (_find?.exams.length > 0) {
                _find.exams.forEach(_exam => {
                    let _hour = "Horas"
                    let _tittle = _exam?.name + " (" + _exam?.delivery_time + " " + _hour + ")";


                    let indication_exams = [];
                    let indication_external = [];

                    if (_exam?.listIndications?.length > 0) {
                        _exam.listIndications.forEach(indication => {
                            indication_exams.push({
                                "id": indication?.id_exam_indication,
                                "state": 3,
                                "text": indication?.indication ?? "-----",
                                "isLeaf": true,
                                "expanded": true
                            });
                        });
                    }
                    else {
                        indication_exams.push({
                            id: null,
                            state: 4,
                            text: "Sin indicaciones de paciente",
                            isLeaf: true,
                            expanded: true
                        });
                    }

                    if (_exam.listLabIndications?.length > 0) {
                        _exam.listLabIndications.forEach(indication => {
                            indication_external.push({
                                "id": indication?.id_exam_laboratory_indication,
                                "state": 3,
                                "text": indication?.indication ?? "-----",
                                "isLeaf": true,
                                "expanded": true
                            });
                        });
                    }
                    else {
                        indication_external.push({
                            "id": null,
                            "state": 4,
                            "text": "Sin indicaciones de laboratorio",
                            "isLeaf": true,
                            "expanded": true
                        });
                    }

                    tree.push({
                        "children": [
                            {
                                "text": "Indicaciones de Pacientes",
                                "children": indication_exams,
                                "isLeaf": true,
                                "expanded": true,
                                "state": 2,
                            },
                            {
                                "text": "Indicaciones de Laboratorio",
                                "children": indication_external,
                                "isLeaf": true,
                                "expanded": true,
                                "state": 2,
                            }
                        ],
                        "id": _exam?.id_exam ?? null,
                        "state": 1,
                        "text": (_exam?.delivery_time === "" || _exam?.delivery_time === null) ? _exam?.name : _tittle ?? "N/A",
                        "isLeaf": false,
                        "expanded": true
                    });
                });
            }
            // ? PROFILES
            if (_find?.profiles.length > 0) {
                _find.profiles.forEach(profile => {
                    let indication_exams = [];
                    let indication_external = [];

                    if (profile?.listIndications?.length > 0) {
                        profile.listIndications.forEach(ind => {
                            indication_exams.push({
                                id: ind?.id_exam_indication,
                                state: 3,
                                text: ind?.indication ?? "-----",
                                isLeaf: true,
                                expanded: true
                            });
                        });
                    } else {
                        indication_exams.push({
                            id: null,
                            state: 4,
                            text: "Sin indicaciones",
                            isLeaf: true,
                            expanded: true
                        });
                    }

                    if (profile?.listLabIndications?.length > 0) {
                        profile.listLabIndications.forEach(ind => {
                            indication_external.push({
                                id: ind?.id_exam_laboratory_indication,
                                state: 3,
                                text: ind?.indication ?? "-----",
                                isLeaf: true,
                                expanded: true
                            });
                        });
                    } else {
                        indication_external.push({
                            id: null,
                            state: 4,
                            text: "Sin indicaciones",
                            isLeaf: true,
                            expanded: true
                        });
                    }

                    tree.push({
                        id: profile?.id_profile,
                        state: 1,
                        text: profile?.name,
                        isLeaf: false,
                        expanded: true,
                        children: [
                            {
                                text: "Indicaciones de Pacientes",
                                children: indication_exams,
                                isLeaf: true,
                                expanded: true,
                                state: 2
                            },
                            {
                                text: "Indicaciones de Laboratorio",
                                children: indication_external,
                                isLeaf: true,
                                expanded: true,
                                state: 2
                            }
                        ]
                    });
                });
            }

        });
        return tree;
    }


    //#endregion

    const format_trunc_number = (_quantity, _decimals) => {
        let _format_number = 0;
        const _base = 10;

        let _number_decimals = Math.pow(_base, _decimals);

        _format_number = Math.round(_quantity * _number_decimals) / _number_decimals;

        return _format_number;
    }

    useMemo(() => {
        let total = 0.0;
        let subtotal = 0.0;
        let total_iva = 0.0;
        let descuento = 0.0;

        let total_exams = 0;
        let total_profiles = 0;
        let _take_number_decimals = 2;

        if (formValues.listQuoterTest.length > 0) {
            formValues.listQuoterTest.forEach(data => {
                console.log("🚀 ~ useMemo ~ data:", data);

                if (data.id_exam !== null) {
                    total_exams++;
                }

                if (data.id_profile !== null) {
                    total_profiles++;
                }

                let value_urgent = parseInt(percentage_urgent_work_order);
                let _valid = (data?.id_agreement > 0) ? data.price_Agremment : data.price;
                console.log("🚀 ~ useMemo ~ _valid:", _valid);

                let price = _valid;
                let urgency = 0.0;
                let taxIva = 0.0;
                let discount = 0.0;

                switch (data.config_iva) {
                    case true:
                        let value_iva = 1 + (data.value_iva / 100);
                        price = (price / value_iva);
                        price = format_trunc_number(price, _take_number_decimals);

                        if (data.is_urgent) {
                            urgency = ((price * value_urgent) / 100);
                            urgency = format_trunc_number(urgency, _take_number_decimals);

                            data.price_urgent = !isNaN(urgency) ? urgency : 0;
                            price = (price + urgency);
                            price = format_trunc_number(price, _take_number_decimals);
                        } else {
                            data.price_urgent = 0;
                        }

                        if (data.auto_redeem) {
                            if (data.id_special_discount !== null || data.id_preloaded_discount) {
                                discount = (price * (data.discount / 100));
                                discount = format_trunc_number(discount, _take_number_decimals);
                                data.amountDiscount = discount;
                            }
                        }

                        taxIva = ((price - discount) * data.value_iva) / 100;
                        taxIva = format_trunc_number(taxIva, _take_number_decimals);
                        break;

                    case false:
                        if (data.is_urgent) {
                            urgency = ((price * value_urgent) / 100);
                            urgency = format_trunc_number(urgency, _take_number_decimals);

                            data.price_urgent = !isNaN(urgency) ? urgency : 0;
                            price = (price + urgency);
                            price = format_trunc_number(price, _take_number_decimals);
                        } else {
                            data.price_urgent = 0;
                        }

                        if (data.percentage > 0) {
                            discount = (price * data.percentage) / 100;
                            discount = format_trunc_number(discount, _take_number_decimals);
                        }

                        if (data.auto_redeem) {
                            if (data.id_special_discount !== null || data.id_preloaded_discount) {
                                discount = (price * (data.discount / 100));
                                discount = format_trunc_number(discount, _take_number_decimals);
                                data.amountDiscount = discount;
                            }
                        }

                        taxIva = ((price - discount) * data.value_iva) / 100;
                        taxIva = format_trunc_number(taxIva, _take_number_decimals);
                        break;
                }

                subtotal += price;
                total_iva += taxIva;
                descuento += discount;
            });
        }

        total = Math.round((subtotal - descuento) + total_iva);

        descuento = !isNaN(descuento) ? parseFloat(descuento.toFixed(2)) : 0;
        subtotal = !isNaN(subtotal) ? parseFloat(subtotal.toFixed(2)) : 0;
        total_iva = !isNaN(Math.round(total_iva)) ? parseFloat(total_iva.toFixed(2)) : 0;
        total = !isNaN(total) ? parseFloat(total.toFixed(2)) : 0;

        setTotalDiscountW(descuento);
        setSubTotalW(subtotal);
        setTotalTaxesW(total_iva);
        setTotalW(total);
    }, [formValues]);



    //#endregion

    const number_format = (cantidad, decimals) => {
        cantidad += '';
        cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

        decimals = decimals || 0;

        if (isNaN(cantidad) || cantidad === 0) {
            return parseFloat(0).toFixed(decimals);
        }

        cantidad = '' + cantidad.toFixed(decimals);

        let cantidad_parts = cantidad.split('.'),
            regexp = /(\d+)(\d{3})/;

        while (regexp.test(cantidad_parts[0]))
            cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

        return cantidad_parts.join('.');
    }

    //#region ALL VALIDATIONS
    const validationTest = (id_exam, id_profile = null, listExams = [], name_profile = "") => {
        let statusValidation = -1;
        let newValidations = {};
        let valid_exist_test = {
            name_profile: "",
            repeat_profiles: [],
            repeat_exams: []
        };

        if (formValues.listQuoterTest.length > 0) {
            let findTest = formValues.listQuoterTest.find(x => (id_exam !== null ? x.id_exam === parseInt(id_exam) : x.id_profile === parseInt(id_profile)));

            if (findTest) {
               newValidations = {
                    ...newValidations,
                    valid_repeat_test: true,
                    title_validation: "Estudios duplicados",
                    message_validation:
                    `El estudio <strong>${findTest.name}</strong> ya se encuentra en la cotización.`
                };

                statusValidation = 0;
            }
            else {
                if (id_exam !== null) {
                    let listProfiles = formValues.listQuoterTest.filter(x => x.id_profile !== null);

                    listProfiles.forEach(p => {
                        if (p.listExams.find(x => x.id_exam === parseInt(id_exam))) {
                            newValidations = {
                                message_validation: "El examen seleccionado ya existe en el perfil: " + p.name
                            };
                            statusValidation = 1;

                            return true;
                        }
                    });
                }
                else if (id_exam === null && id_profile !== null) {
                    let filterProfiles = formValues.listQuoterTest.filter(x => x.id_profile !== null);

                    filterProfiles.forEach(p => {
                        let examsRepeat = [];
                        let examsNotRepeat = [];

                        p.listExams.forEach(e => {
                            if (listExams.find(x => x.id_exam === e.id_exam)) {
                                examsRepeat.push(e);
                            }
                        });

                        let notExist = [];
                        listExams.forEach(x => {
                            if (!examsRepeat.find(r => r.id_exam === x.id_exam)) {
                                notExist.push(x);
                            }
                        });

                        examsNotRepeat = notExist;

                        if (examsRepeat.length > 0) {
                            valid_exist_test.repeat_profiles.push({
                                name_profile: p.name,
                                listExamsRepeat: examsRepeat,
                                listExamsNotRepeat: examsNotRepeat
                            });
                        }

                        if (valid_exist_test.repeat_profiles.length > 0 || valid_exist_test.repeat_exams.length > 0) {
                            valid_exist_test.name_profile = name_profile;
                            newValidations = {
                                message_validation: "Hay exÃ¡menes o perfiles repetidos"
                            };

                            statusValidation = 2;
                        }
                    });

                    if (valid_exist_test.repeat_profiles.length > 0 || valid_exist_test.repeat_exams.length > 0) {
                        valid_exist_test.name_profile = name_profile;
                        newValidations = {
                            message_validation: "Hay exÃ¡menes o perfiles repetidos"
                        };

                        statusValidation = 2;
                    }

                    let listExamsW = formValues.listQuoterTest.filter(x => x.id_exam !== null);

                    listExamsW.forEach(e => {
                        if (listExams.find(x => x.id_exam === parseInt(e.id_exam))) {
                            newValidations = {
                                message_validation: `Tienes examenes duplicados: ${e.name}, al seleccionar el perfil`
                            };

                            statusValidation = 3;

                            return true;
                        }
                    })
                }
            }
        }

        setValidationsTest(newValidations);
        setValidationsRepeat({
            ...validationsRepeat,
            name_profile: valid_exist_test.name_profile,
            repeat_profiles: valid_exist_test.repeat_profiles,
            repeat_exams: valid_exist_test.repeat_exams
        });

        return {
            status: statusValidation,
            title: newValidations.title_validation ?? "",
            message: newValidations.message_validation ?? ""
        };
    }

    const validArrayCurva = () => {
        let statusValidation = false;

        if (formValues.listQuoterTest.length > 0) {
            formValues.listQuoterTest.forEach(obj => {
                if (obj.is_curve) {
                    obj.curves_aux.forEach(c => {
                        if (c.time === "") {
                            statusValidation = true;
                            return;
                        }
                    })
                }
            })
        }
        else {
            statusValidation = true;
        }

        return statusValidation;
    }

    const validArrayCurva1 = () => {
        let statusValidation = false;

        if (formValues.listQuoterTest.length > 0) {
            formValues.listQuoterTest.forEach(obj => {
                if (obj.is_curve) {
                    if (obj.price === 0) {
                        statusValidation = true;
                        return;
                    }
                }
            })
        }
        else {
            statusValidation = true;
        }

        return statusValidation;
    }

    //#endregion

    //#region validations
    const validationQuatation = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name === "") {
            newValidations = {
                ...newValidations,
                nameV: true,
            };

            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                nameV: false,
            };
        }
        if (formValues.paternal_surname === "") {
            newValidations = {
                ...newValidations,
                paternal_surnameV: true,
            };

            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                paternal_surnameV: false,
            };
        }
        if (formValues.maternal_surname === "") {
            newValidations = {
                ...newValidations,
                maternal_surnameV: true,
            };

            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                maternal_surnameV: false,
            };
        }
        setvalidationsSG(newValidations);
        return statusValidation;
    }
    //#endregion validations

    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            // createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
            showToastAlert(
                "error",
                nameMethod,
                "Ocurrio un error en el servidor"
            );
        }
        else {
            showToastAlert(
                "error",
                "Error PDF",
                "No se descargo el PDF"
            );
            // createSweet("warning", "warning", nameMethod, response.data.msg);
            showToastAlert(
                    "warning",
                    nameMethod,
                    response.data.msg
                );
        }

        return null;
    }

    // #region Preview pdf quoter

    const handleOpenPreview = async (id_quoter) => {

        setLoadingPreviewId(id_quoter);

        try {


            let data = {
                id_quoter,
                print_result: true,
                send_email: false,
                email_client: ""
            };

            const token = localStorage.getItem("token");
            const response = await fetch(ConfigServer.serverUrl + "/api/Quoter/CreateDocumentQuoter", {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                }
            });

            if (response.status !== 200) {
                showToastAlert(
                    "error",
                    "Eror en el PDF",
                    "No se pudo generar el PDF"
                );
                // createSweet("warning", "warning", "No se pudo generar el PDF");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            setPdfPreviewUrl(url);
            setShowPreview(true);
        } finally {
            setLoadingPreviewId(null);
        }
    };


    //#endregion


    //#region SEARCH QUOTER
    const handleSearch = (e) => {
        let busqueda = e.target.value.toUpperCase();
        console.log("Buscando:", busqueda);

        if (busqueda === "") {
            console.log("Busqueda vacía, restaurando todos");
            setDataQuoter(allQuoters);
            return;
        }

        const filtered = allQuoters.filter(element => {
            const code = element.code?.toString().toUpperCase() || "";
            const company_name = element.company_name?.toUpperCase() || "";
            const client = element.client?.toUpperCase() || "";

            console.log("Comparando elemento:", { code, company_name, client });

            return code.includes(busqueda) || company_name.includes(busqueda) || client.includes(busqueda);
        });

        console.log("Filtrados:", filtered);

        setDataQuoter(filtered);
    };



    //#endregion


    const exportExcel = async () => {

        try {
            const XLSX = await import("xlsx");

            const _report = dataQuoter.map(quoter => ({
                Código: quoter.code ?? "---",
                Fecha_creación: quoter.created_at ?? "---",
                Tipo: quoter.client_type?.props?.children ?? (quoter.client_type ?? "---"),
                Empresa: quoter.company_name ?? "---",
                Cliente: quoter.client ?? "---",
                Estatus: quoter.status?.props?.children ?? (quoter.status ?? "---"),
                Fecha_uso: quoter.used_at ?? "---",

            }));


            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Cotizaciones.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar a Excel:", error);
        }

    };


    const handleViewQuoter = () => {
        setViewDetailQuoter(true)
        setViewIndication(false)
    }

    const handleClosedQuoter = () => {
        setViewDetailQuoter(false)
    }

    const handleViewIndications = () => {
        setViewIndication(true)
        setViewDetailQuoter(false)
    }

    const handleClosedIndications = () => {
        setViewIndication(false)
    }

    const resetQuotationForAgreement = () => {

        setViewQuoter(false);
        setLoadingCreate(false);
        setIdQuoter(0);

        handleUpdateValues({
            observations: "",
            listQuoterTest: [],
            id_profileExam: 0,
            name: url === cedimi ? "A" : "",
            paternal_surname: url === cedimi ? "QUIEN" : "",
            maternal_surname: url === cedimi ? "CORRESPONDA" : "",
            email: "",
            phone: "",
            id_preloaded_discount: null,
            arrayCurves: [],
            id_agreement: formValues.id_agreement // conserva el convenio actual
        });

        setExamProfileState({});
        setItemsTree([]);
    };

    const clearQuotationTests = () => {
 
       handleUpdateValues(prev => ({
    ...prev,
    listQuoterTest: [],
    id_profileExam: 0
}));

    };

   const handleApplyDiscount = async () => {
        try {
            setLoadingDiscount(true);
            await validatePreloadedDiscount();
        } finally {
            setLoadingDiscount(false);
        }
    };


    const handleNewQuotation = (typeClient) => {

        setViewQuoter(false);
        setLoadingCreate(false);
        setIdQuoter(0);

        setSelectedCompany(null);

        handleUpdateValues({
            observations: "",
            listQuoterTest: [],
            id_profileExam: 0,
            name: url === cedimi ? "A" : "",
            paternal_surname: url === cedimi ? "QUIEN" : "",
            maternal_surname: url === cedimi ? "CORRESPONDA" : "",
            email: "",
            phone: "",
            id_agreement: null,
            id_preloaded_discount: null,
            arrayCurves:[]
            
        });

        setExamProfileState({});
        setItemsTree([]);

        handleChangeTypeClient(typeClient);

        if (typeClient === 1) {
            setActiveView(1);
        } else if (typeClient === 3) {
            setActiveView(2);
        } else {
            setActiveView(0);
        }
    }

    const goToListQuoter = (typeClient = chekTypeClient) => {

        const pending = {
            action: "LIST",
            type: typeClient
        };

        setPendingType(pending);

        showCustomAlert({
            mode: "confirm",
            type: "info",
            title: "¿Cambiar tipo de cotización?",
            message: `Los datos capturados actualmente se perderán al cambiar entre <strong>Paciente Particular</strong> y <strong>Empresas</strong>.`,
            buttonText: "Sí, continuar",
            cancelText: "Permanecer aquí",
            onAccept: () => confirmTabChange(pending),
            onCancel: cancelTabChange
        });
    };

    
    
    const confirmNewQuotation = (typeClient, valid = -1) => {
        if (valid === -1) {
            showCustomAlert({
                mode: "confirm",
                title: "¿Crear una nueva cotización?",
                message: "Al crear una nueva cotización perderás los datos.",
                buttonText: "Sí, continuar",
                cancelText: "Cancelar",
                onAccept: () => handleNewQuotation(typeClient),
                onCancel: cancelNewQuotationAlert
            });
            return;
        }

        handleNewQuotation(typeClient);
    };

    const confirmNewQuotationAlert = () => {

        handleNewQuotation(pendingQuotationType);
        setPendingQuotationType(null);
    };

    const cancelNewQuotationAlert = () => {
        setPendingQuotationType(null);
    };

    const confirmTabChange = (pending) => {

        if (pending.action === "LIST") {

            handleNewQuotation(pending.type);
            getQuoter();
            setActiveView(0);

        } else {

            handleChangeTypeClient(pending.type);
            setActiveView(pending.view);

        }

        setPendingType(null);
    };

    const requestChangeType = (view, type) => {

        const pending = {
            view,
            type
        };

        setPendingType(pending);

        showCustomAlert({
            mode: "confirm",
            type: "info",
            title: "¿Cambiar tipo de cotización?",
            message: `Los datos capturados actualmente se perderán al cambiar entre <strong>Paciente Particular</strong> y <strong>Empresas</strong>.`,
            buttonText: "Sí, continuar",
            cancelText: "Permanecer aquí",
            onAccept: () => confirmTabChange(pending),
            onCancel: cancelTabChange
        });
    };


    const cancelTabChange = () => {
        setPendingType(null);
    };

    //? ALERT DUPLICE
    const showDuplicateExamAlert = (title, message) => {
         showCustomAlert({
            mode: "alert",
            type: "warning",
            title,
            message,
            buttonText: "Aceptar",
            onAccept: closeDuplicateExamAlert
        });

    };

    const closeDuplicateExamAlert = () => {
        setDuplicateMessage("");
    };

    //? ALERT IT DOES NOT EXIST IN THE AGREEMENT
    const showInfoAlert = (title, message) => {

        showCustomAlert({
            mode: "alert",
            type: "warning",
            title,
            message,
            buttonText: "Aceptar",
            onAccept: closeDuplicateExamAlert
        });

    };
    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };

    const closeToastAlert = () => {

        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };
    return {
        // ? DIALOG QUOTER
        modalTitle, modalRepeatProfile, modalViewExamsP, toggleModalViewExams, toggleRepeatProfile,

        // ? VALUE
        observations, listQuoterTest, name, paternal_surname, maternal_surname, email,
        handleInputChange, totalW, subTotalW, totalTaxesW,
        examProfileState, viewExamsProfile, viewButtons, validationsRepeat,

        // ? QUOTER METHODS
        handleSelectExamChange, deleteExamProfile, handleCheckUrgent, handleCheckSpecimen,
        handleViewExamsProfile, saveCreate, sentPdf, phone, validationsSG, handleChangePercentage, lab,

        // ? CONFIGURATION QUOTER
        itemsTree, treeviewRef,

        // ? CONFIGURATION TYPE CLIENT 
        handleChangeTypeClient, chekTypeClient, id_agreement, listAgreement, handleSelectValues, loadingQuoter, number_format,

        // ? CONFIGURATION SEARCH QUOTER
        dataQuoter, handleFilterValues, date_ini, date_end, searchQuotes, downdloadQuoter, handleMouseEnter, handleMouseLeave, isHovered,

        showPreview, pdfPreviewUrl, handleOpenPreview, setPdfPreviewUrl, setShowPreview,
        loadingDownloadId, loadingPreviewId, handleSearch, exportExcel, loadingQuoterFilter,

        // ? CONFIGURATION PRELOADED
        listPreloaded, id_preloaded_discount, validatePreloadedDiscount, activeIndex, setActiveIndex, loading, progress, totalDiscountW,

        // ? CONFIGURATION HEADER
        viewDetailQuoter, handleViewQuoter, handleClosedQuoter,
        viewIndication, handleViewIndications, handleClosedIndications, loadingCreate, viewQuoter, loadingSend,
        removePreloadedDiscount,


        //? SEARCH QUOTER
        setSelectedCompany, selectedCompany,clearQuotationTests,resetQuotationForAgreement, 

        //? DISCOUNT FOOTER
        handleApplyDiscount, loadingDiscount,

        //? BUTTONS FOOTER
        handleNewQuotation, activeView, goToListQuoter, setActiveView, confirmNewQuotation,

        //? ALERT GLOBAL
        requestChangeType, confirmTabChange, cancelTabChange, confirmNewQuotationAlert, cancelNewQuotationAlert,
        duplicateMessage,
        closeDuplicateExamAlert,

        //? ALERT IT DOES NOT EXIST IN THE AGREEMENT
        showInfoAlert, duplicateTitle,

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        showToastAlert,
        closeToastAlert,

        customAlert
    }
}